/* eslint-disable flowtype/require-valid-file-annotation */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import withStyles from 'material-ui/styles/withStyles'
import Button from 'material-ui/Button'
import Checkbox from 'material-ui/Checkbox'
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle,
} from 'material-ui/Dialog'
import Messages from '../constants/messages'
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'material-ui/Table'
import LoadingIndicator from '../components/loadingIndicator'

const PROP_TYPES = {
  addToSelected:PropTypes.func.isRequired,
  buttonLabel:PropTypes.string.isRequired,
  resetDialog:PropTypes.func.isRequired,
  data:PropTypes.array.isRequired,
  handleSubmit:PropTypes.func.isRequired,
  selected:PropTypes.array.isRequired,
  showDialog:PropTypes.bool.isRequired,
  title:PropTypes.string.isRequired,
  openDialog:PropTypes.func.isRequired
}

const styles = theme => ({
  root: {
    float: 'right',
    marginBottom: 15
  },
  header: {
    fontSize: 18
  },
  table: {
    tableLayout: 'fixed'
  },
  tableRow: {
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  },
  checkbox: {
    width: 1
  },
  btn: {
    textAlign: 'right'
  }
})

export class TableDialog extends Component {

  componentWillMount(){
    this.props.resetDialog()
  }

  componentWillUnmount(){
    this.props.resetDialog()
  }

  handleClick = (event, id) => {
    const { addToSelected, selected } = this.props
    const selectedIndex = selected.indexOf(id)
    let newSelected = []

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id)
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1))
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1))
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      )
    }
    addToSelected(newSelected)
  }

  isSelected = id => this.props.selected.indexOf(id) !== -1

  renderButton() {
    const { buttonLabel, classes, openDialog } = this.props

    return (
      <div className={classes.btn}>
        <Button raised color="primary" onClick={openDialog} id="dialogBtn">
          {buttonLabel}
        </Button>
      </div>
    )
  }

  renderData() {
    const { classes, data, userData } = this.props
    let markup = null
    let uniqueData = data.filter(item => {
      return !userData.some(userItem => userItem.id === item.id)
    })
    if (uniqueData.length > 0) {
      markup = uniqueData.map(n => {
        const isSelected = this.isSelected(n.id)
        return (
          <TableRow
            hover
            className={classes.tableRow}
            onClick={event => this.handleClick(event, n.id)}
            role="checkbox"
            aria-checked={isSelected}
            tabIndex={-1}
            key={n.id}
            selected={isSelected}>
            <TableCell className={classes.checkbox} >
              <Checkbox checked={isSelected} />
            </TableCell>
            <TableCell>{n.name}</TableCell>
          </TableRow>
        )
      })
    } else {
      markup = (
        <TableRow hover tabIndex={-1}>
          <TableCell className={classes.checkbox}></TableCell>
          <TableCell>N/A</TableCell>
          <TableCell>N/A</TableCell>
        </TableRow>
      )
    }
    return markup
  }

  renderTableHeaders() {
    const { classes } = this.props

    return (
      <TableHead className={classes.header}>
        <TableRow>
          <TableCell className={classes.checkbox}></TableCell>
          <TableCell>{Messages['uiComponents']['TABLE_NAME_COLUMN']}</TableCell>
        </TableRow>
      </TableHead>
    )
  }

  renderTable() {
    const { classes } = this.props
    return (
      <Table className={classes.table} id="dialogTable">
        {this.renderTableHeaders()}
        <TableBody>
          {this.renderData()}
        </TableBody>
      </Table>
    )
  }

  renderDialog() {
    const {
      resetDialog,
      handleSubmit,
      infoText,
      isLoading,
      showDialog,
      title } = this.props

    return (
      <Dialog open={showDialog} onRequestClose={resetDialog}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          { isLoading ? <LoadingIndicator
            infoText={infoText ? infoText : Messages['uiComponents']['LOADING_MSG']}
            isDialog={true}/> : this.renderTable() }
        </DialogContent>
        <DialogActions>
          <Button onClick={resetDialog} color="primary">
            {Messages['uiComponents']['FORM_DIALOG_CANCEL_BUTTON_LABEL']}
          </Button>
          <Button onClick={handleSubmit} color="primary">
            {Messages['uiComponents']['FORM_DIALOG_SUBMIT_BUTTON_LABEL']}
          </Button>
        </DialogActions>
      </Dialog>
    )
  }

  render() {
    const { classes } = this.props

    return (
      <div className={classes.root}>
        {this.renderButton()}
        {this.renderDialog()}
      </div>
    )
  }
}

TableDialog.propTypes = PROP_TYPES

export default withStyles(styles)(TableDialog)
